import React from 'react';
import './Retirement.css';

import Icon from '../../../components/Icon/Icon';

const retirement = ( props ) => (
	<section id="Retirement">
		<h2>401<span>(k)</span></h2>
		<p>
			Want to retire and live your best life on an island somewhere? You can sign up for and make changes to your 401(k) at <a href="http://mykplan.com" target="_blank" rel="noopener noreferrer">mykplan.com</a>.
		</p>
		<p>
			You can also call our fund manager for advice on managing your 401(k):
			<br />
			Cindy Pierce | (202) 434-4718
		</p>
		<p>
			The company match amount is determined at the end of each fiscal year. It's 50% vested after 2 years of service, and 100% vested after 3 years (based on start date). You must work 1,000 hours per plan year and be employed on December 31 of that same year to be eligible for the vested company match. Your personal contributions are always 100% vested!
		</p>
		<div className="section">
			<Icon icon="benefits.scroogeMcDuck" gradient="vertical" />
			<p className="links inner-section">
				For more information on saving for retirement, check out:
				<a href="https://www.dol.gov/sites/default/files/ebsa/about-ebsa/our-activities/resource-center/publications/top-10-ways-to-prepare-for-retirement.pdf" target="_blank" rel="noopener noreferrer">
					Top 10 Ways to Prepare for Retirement (Department of Labor)
				</a>
				<a href="https://www.usa.gov/retirement" target="_blank" rel="noopener noreferrer">
					Retirement Information (US Government)
				</a>
				<a href="https://www.irs.gov/retirement-plans/plan-participant-employee/saving-for-retirement" target="_blank" rel="noopener noreferrer">
					Saving for Retirement (IRS)
				</a>
			</p>
		</div>
	</section>
);

export default retirement;



// WEBPACK FOOTER //
// ./src/pages/Benefits/Retirement/Retirement.js